import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const getDeviceId = () => {
  let id = localStorage.getItem("pp_device_id");
  if (!id) {
    id = crypto.randomUUID();
    localStorage.setItem("pp_device_id", id);
  }
  return id;
};

export const hasPlease = (t) => /\bplease\b|\bpls\b|\bplz\b/i.test(t);
export const hasThanks = (t) => /\bthank\s*(you|u)\b|\bthanks\b|\bthx\b|\bty\b/i.test(t);

export const transcribe = async (blob) => {
  const fd = new FormData();
  fd.append("audio", blob, "clip.webm");
  const { data } = await axios.post(`${API}/transcribe`, fd);
  return data.text;
};

export const checkManners = async (text, age) =>
  (await axios.post(`${API}/manners/check`, { text, age })).data;

export const streamAnswer = async (directive, age, onChunk) => {
  const res = await fetch(`${API}/ask`, {
    credentials: "include",
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ directive, age }),
  });
  if (!res.ok) throw new Error("AI could not answer");
  const reader = res.body.getReader();
  const dec = new TextDecoder();
  let buf = "";
  for (;;) {
    const { done, value } = await reader.read();
    if (done) break;
    buf += dec.decode(value, { stream: true });
    const parts = buf.split("\n\n");
    buf = parts.pop();
    for (const p of parts) {
      const d = p.replace(/^data: /, "");
      if (d === "[DONE]") return;
      onChunk(JSON.parse(d).t);
    }
  }
};

export const saveConversation = async (conv) =>
  (await axios.post(`${API}/conversations`, { ...conv, device_id: getDeviceId() })).data;

export const listConversations = async (profileId) =>
  (await axios.get(`${API}/conversations/${getDeviceId()}`, { params: profileId ? { profile_id: profileId } : {} })).data;

export const getAcorns = async (profileId) =>
  (await axios.get(`${API}/acorns/${getDeviceId()}`, { params: { profile_id: profileId } })).data;

export const coachApology = async (body) => (await axios.post(`${API}/sorry/coach`, body)).data;

export const saveApology = async (a) => (await axios.post(`${API}/apologies`, { ...a, device_id: getDeviceId() })).data;

export const practiceTurn = async (body) => (await axios.post(`${API}/practice/turn`, body)).data;

export const completePractice = async (p) => (await axios.post(`${API}/practice/complete`, { ...p, device_id: getDeviceId() })).data;

export const clearConversations = async (pin, profileId) =>
  axios.delete(`${API}/conversations/${getDeviceId()}`, {
    params: profileId ? { profile_id: profileId } : {},
    headers: { "X-Parent-Pin": pin },
  });

export const VOICES = [["shimmer", "Shimmer", "bright & cheerful"], ["nova", "Nova", "energetic & upbeat"], ["coral", "Coral", "warm & friendly"]];
export const getVoice = () => localStorage.getItem("pp_profile_voice") || localStorage.getItem("pp_voice") || "shimmer";
export const setProfileVoice = (v) => (v ? localStorage.setItem("pp_profile_voice", v) : localStorage.removeItem("pp_profile_voice"));
export const setVoice = (v) => localStorage.setItem("pp_voice", v);

const robotSpeak = (text) => {
  if (!window.speechSynthesis) return;
  const u = new SpeechSynthesisUtterance(text);
  u.rate = 0.95;
  window.speechSynthesis.speak(u);
};

let current = null;
export const stopSpeaking = () => { current?.pause(); current = null; window.speechSynthesis?.cancel(); };
export const speak = async (text, voice = getVoice()) => {
  current?.pause();
  window.speechSynthesis?.cancel();
  const audio = new Audio();
  current = audio;
  try {
    const { data } = await axios.post(`${API}/speak`, { text: text.slice(0, 4000), voice }, { responseType: "blob" });
    if (current !== audio) return;
    audio.src = URL.createObjectURL(data);
    await audio.play();
  } catch {
    if (current === audio) robotSpeak(text);
  }
};
